import React from "react";
import { useTranslation } from "react-i18next";
import imageContent from "../../assets/image-info-banner-content.png";
import imageSearch from "../../assets/image-info-banner-search.png";
import imageShopping from "../../assets/image-info-banner-shopping.png";

export const InfoBanner = ({}) => {
  const { t } = useTranslation("translation", { keyPrefix: "Wizard Image Selection Page" });
  return (
    <div
      className="flexWrapUnder800"
      style={{ marginBottom: "20px", display: "flex", flexDirection: "row", gap: "30px", justifyContent: "center" }}
    >
      <div
        style={{
          border: "1px solid var(--app-border)",
          borderRadius: "var(--app-radius-box)",
          // the rounding has to clip the caption strip below, which carries its own background
          overflow: "hidden",
          minWidth: "400px",
          display: "flex",
          flexDirection: "column",
          flexGrow: 2,
        }}
      >
        <div style={{ padding: "20px", display: "flex", flexDirection: "row", gap: "30px", justifyContent: "center" }}>
          <img alt={t("Image info banner search image alternate")} src={imageSearch} width="156" />
          <img alt={t("Image info banner content image alternate")} src={imageContent} width="156" />
        </div>
        <div
          style={{
            padding: "25px",
            flexGrow: 1,
            textAlign: "center",
            color: "var(--app-text-subtle)",
            fontSize: "20px",
            background: "var(--app-text-subtle-tint)",
          }}
        >
          {t("Image info banner selection")}
        </div>
      </div>

      <div
        style={{
          border: "1px solid var(--app-border)",
          borderRadius: "var(--app-radius-box)",
          overflow: "hidden",
          minWidth: "300px",
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
        }}
      >
        <div style={{ padding: "20px", display: "flex", flexDirection: "row", gap: "30px", justifyContent: "center" }}>
          <img alt={t("Image info banner shopping image alternate")} src={imageShopping} width="156" />
        </div>
        <div
          style={{
            padding: "25px",
            flexGrow: 1,
            textAlign: "center",
            color: "var(--app-text-subtle)",
            fontSize: "20px",
            background: "var(--app-text-subtle-tint)",
          }}
        >
          {t("Image info banner shopping")}
        </div>
      </div>
    </div>
  );
};
